import { giphyAqua, giphyGreen, giphyPink, giphyPurple, giphyYellow } from '@giphy/colors'
import { Gradient } from 'types'
import type Icon from 'ui/src/types/icons'
import { UGEEditor } from '../types'

export function colorFromEditor(editor: UGEEditor): string {
    switch (editor) {
        case 'captions':
            return giphyPink
        case 'crop':
            return giphyAqua
        case 'default':
        case 'filters':
            return giphyPurple
        case 'layers':
            return giphyYellow
        case 'stickers':
            return giphyGreen
    }
}

export function gradientFromEditor(editor: UGEEditor): Gradient {
    switch (editor) {
        case 'captions':
            return 'red-pink'
        case 'crop':
            return 'indigo-cyan'
        case 'default':
        case 'filters':
            return 'indigo-purple'
        case 'layers':
            return 'red-yellow'
        case 'stickers':
            return 'blue-green'
    }
}

export function iconFromEditor(editor: UGEEditor): Icon {
    switch (editor) {
        case 'captions':
            return 'caption'
        case 'crop':
            return 'crop'
        case 'default':
            return 'edit'
        case 'filters':
            return 'filter'
        case 'layers':
            return 'layers'
        case 'stickers':
            return 'sticker-outline'
    }
}

export function iconScaleFromEditor(editor: UGEEditor): number {
    switch (editor) {
        case 'crop':
            return 1.4
        case 'captions':
        case 'filters':
        case 'layers':
            return 1.2
        case 'stickers':
            return 1.1
        default:
            return 1
    }
}
